import React from 'react';
import { SmartCaptcha as YandexSmartCaptcha } from '@yandex/smart-captcha';

interface SmartCaptchaProps {
  sitekey?: string;
  onSuccess: (token: string) => void;
  resetKey?: number;
}

const SmartCaptcha: React.FC<SmartCaptchaProps> = ({ 
  sitekey = "ysc1_d6fa5e06gmcFxkwd8aObV87DHDsmKnk3mgdDQdqhe9c8dbd7",
  onSuccess,
  resetKey 
}) => {
  return (
    <div>
      <YandexSmartCaptcha
        sitekey={sitekey}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default SmartCaptcha;
